module.exports = __webpack_public_path__ + "img/google-play-ms.e5cb01ab.png";